import React, { Component, useState } from "react";
import {
  SettingOutlined,
  DesktopOutlined,
  LogoutOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Drawer, Menu, Tooltip, notification } from "antd";
import ThemeConfigurator from "./ThemeConfigurator";
import { connect } from "react-redux";
import { DIR_RTL } from "constants/ThemeConstant";

import { BASE_URL } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import { signOutSuccess, signOut } from "redux/actions/Auth";
import { AUTH_TOKEN } from "../../redux/constants/Auth";

export class NavPanel extends Component {
  state = { visible: false, loading: false };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  handleClick = () => {
    this.setState({
      loading: true,
    });
    JwtAuthService.logout()
      .then((resp) => {
        signOut();
        notification.success({
          message: `Exit Successful`,
          description: `You are being redirected`,
        });
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem("role");

        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      })
      .then((e) => {
        // showAuthMessage(e);
        console.log(e);
      });
  };

  render() {
    return (
      <>
        <Menu mode="horizontal">
          <Menu.Item key="logout" onClick={() => this.handleClick()}>
            <Tooltip placement="bottom" title="Logout">
              <a>
                {this.state.loading ? (
                  <LoadingOutlined className="nav-icon mr-0" />
                ) : (
                  <LogoutOutlined className="nav-icon mr-0" />
                )}
              </a>
            </Tooltip>
          </Menu.Item>

          <Menu.Item key="showSite">
            <Tooltip placement="bottom" title="Preview">
              <a href={BASE_URL} target="_blank" rel="noreferrer">
                <DesktopOutlined className="nav-icon mr-0" />
              </a>
            </Tooltip>
          </Menu.Item>
          {/* <Menu.Item key="panel" onClick={this.showDrawer}>
            <a href="#">
              <SettingOutlined className="nav-icon mr-0" />
            </a>
          </Menu.Item> */}
        </Menu>
        {/* <Drawer
          title="Theme Configaaa"
          placement={this.props.direction === DIR_RTL ? "left" : "right"}
          width={350}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <ThemeConfigurator />
        </Drawer> */}
      </>
    );
  }
}

const mapStateToProps = ({ theme }) => {
  const { locale } = theme;
  return { locale };
};

export default connect(mapStateToProps)(NavPanel);
